import { writable } from 'svelte/store';
export const accessToken = writable("");
export const user = writable();
export const campaignNewActive = writable(false);
export const campaignDetailActive = writable(false);
export const selectedCampaign = writable();
export const selectedCharacter = writable(undefined);
export const selectedCharacterTab = writable(0);
export const selectedGameTab = writable('default');
export const socket = writable();
export const ownerSocketID = writable("");
export const userIDPairs = writable({});
export const messageMode = writable(0);
export const modifyCharacter = writable();
export const sendSkillCheck = writable();
export const formatModifier = writable();
export const createNewAttack = writable();
export const addNewResource = writable();
